import { TAnswers } from 'models/common.model'
import { IConfig } from 'models/config.model'
import { IVariant } from 'models/variant.model'
import { AnyAction } from 'redux'
import {
  RESET_ERROR,
  SET_CONFIG,
  SET_ERROR,
  SET_VARIANT,
  START_FETCHING,
  STOP_FETCHING,
  RESET_ANSWERS,
  SET_ANSWERS,
  SET_ANSWERS_FROM_BACKEND,
  SET_OPTIMIZE_VARIANT_MAP,
  SET_SCREEN_NAME,
  SET_SUBSCRIPTION_LIST,
  SET_LANGUAGE,
} from 'root-redux/actions/common'
import { ScreenName } from 'root-constants'
import { ISubscription } from 'models/subscriptions.model'

const initState: ICommonState = {
  isFetching: false,
  actionList: [],
  error: null,
  currentVariant: null,
  subscriptions: [],
  config: null,
  answers: null,
  optimizeVariantMap: null,
  screenName: ScreenName.ONBOARDING,
  language: '',
}

export interface ICommonState {
  isFetching: boolean
  actionList: string[]
  error: any
  currentVariant: IVariant | null
  subscriptions: ISubscription[]
  config: IConfig | null
  answers: TAnswers | null
  optimizeVariantMap: Record<string, string> | null
  screenName: ScreenName
  language: string
}

export function commonReducer(
  state: ICommonState = initState,
  { type, payload = null }: AnyAction,
): ICommonState {
  switch (type) {
    case START_FETCHING: {
      return {
        ...state,
        isFetching: true,
        actionList: state.actionList.concat(payload),
      }
    }
    case STOP_FETCHING: {
      return {
        ...state,
        isFetching: !!payload.length,
        actionList: payload,
      }
    }
    case SET_ERROR: {
      return {
        ...state,
        error: payload,
      }
    }
    case RESET_ERROR: {
      return {
        ...state,
        error: null,
      }
    }
    case SET_VARIANT: {
      return {
        ...state,
        currentVariant: payload,
      }
    }
    case SET_SUBSCRIPTION_LIST: {
      return {
        ...state,
        subscriptions: payload,
      }
    }
    case SET_CONFIG: {
      return {
        ...state,
        config: payload,
      }
    }
    case SET_ANSWERS: {
      return {
        ...state,
        answers: { ...state.answers, ...payload },
      }
    }
    case SET_ANSWERS_FROM_BACKEND: {
      return {
        ...state,
        answers: payload,
      }
    }
    case RESET_ANSWERS: {
      return {
        ...state,
        answers: null,
      }
    }
    case SET_OPTIMIZE_VARIANT_MAP: {
      return {
        ...state,
        optimizeVariantMap: { ...state.optimizeVariantMap, ...payload },
      }
    }
    case SET_SCREEN_NAME: {
      return {
        ...state,
        screenName: payload,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        language: payload,
      }
    }
    default:
      return state
  }
}
